<p-table
  *ngIf="model"
  [value]="data.items"
  [lazy]="model.serverSide && !model.groupBy"
  (onLazyLoad)="model.serverSide && !isMutating && onLoadData($event)"
  rowGroupMode="subheader"
  [groupRowsBy]="groupRowsBy"
  [expandedRowKeys]="expandedRowKeys"
  [paginator]="!model.disablePaging ?? true"
  [dataKey]="dataKey"
  paginatorDropdownAppendTo="body"
  [rows]="rows"
  [first]="data.firstIndex ?? 0"
  [totalRecords]="data.totalCount"
  [loading]="isLoading"
  styleClass="p-datatable-sm"
  stripedRows
  [resizableColumns]="true"
  [columns]="visibleColumns"
  [columnResizeMode]="'expand'"
  [sortMode]="model.sortMode ?? null"
  [sortField]="model.sortBy?.field"
  [sortOrder]="model.sortBy?.order ?? 1"
  [customSort]="!!model.sortBy?.sortFn"
  (sortFunction)="model.sortBy?.sortFn && customSort($event)"
  [reorderableColumns]="true"
  [reorderableRows]="model.supportsReordering"
  (onRowReorder)="onRowReorder($event)"
  [rowTrackBy]="trackByFn"
  [showInitialSortBadge]="true"
  [scrollable]="true"
  [scrollHeight]="model.scrollHeight"
  (onPage)="onPageChange()"
  [currentPageReportTemplate]="'{first}-{last} of ' + data.totalCount"
  [showCurrentPageReport]="!!data.totalCount"
  [rowsPerPageOptions]="rowsPerPageOptions"
  [selectionMode]="model.selectionMode ?? null"
  [selection]="selectedRows"
  (selectionChange)="onRowsChecked($event)"
>
  <ng-template pTemplate="caption">
    <div class="caption">
      <div class="caption--main sh-button-group">
        <ng-content select="[caption-main]"></ng-content>
        <p-button
          *ngIf="hasFilters"
          [pTooltip]="'table.resetFilters' | translate"
          icon="pi pi-filter-slash"
          styleClass="p-button-outlined p-button-secondary p-button-sm"
          (click)="resetFilters()"
        ></p-button>
      </div>
    </div>
  </ng-template>
  <ng-template pTemplate="header" let-columns>
    <tr>
      <th *ngIf="model.supportsReordering" style="width: 3rem"></th>
      <th *ngIf="isMultipleSelection" class="checkbox-cell">
        <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
      </th>
      <ng-container *ngFor="let column of columns; trackBy: trackByColumn">
        <th
          [pSortableColumn]="column.key"
          pResizableColumn
          pReorderableColumn
          [attr.is-active]="activeFilters[column.key]"
          [attr.type]="column.fieldType"
        >
          <div class="coll">
            <div class="coll-name">
              {{ column.name | translate }}
            </div>

            <p-sortIcon
              *ngIf="!model.groupBy"
              [field]="column.key"
            ></p-sortIcon>

            <ng-container [ngSwitch]="true" *ngIf="model.enableFiltering">
              <p-columnFilter
                *ngSwitchDefault
                [type]="
                  columnFilterTypes[
                    column.fieldType ?? FieldType.SingleLineText
                  ]
                "
                [field]="column.key"
                [showOperator]="false"
                [showAddButton]="false"
                display="menu"
              >
              </p-columnFilter>
            </ng-container>
          </div>
        </th>
      </ng-container>
      <th
        *ngIf="model.rowActions"
        alignFrozen="right"
        pFrozenColumn
        [frozen]="true"
      ></th>
    </tr>
  </ng-template>
  <ng-template
    *ngIf="model.groupBy"
    pTemplate="groupheader"
    let-group
    let-expanded="expanded"
  >
    <tr class="row-group-header">
      <td [attr.colspan]="totalCollspan">
        <div class="group-header">
          <p-checkbox
            *ngIf="isMultipleSelection"
            [binary]="true"
            [ngModel]="isGroupChecked(group)"
            [indeterminate]="isGroupIndeterminate(group)"
            (onChange)="
              $event.originalEvent.stopPropagation();
              toggleGroupSelection(group)
            "
          ></p-checkbox>
          <button
            type="button"
            pButton
            pRipple
            [pRowToggler]="group"
            class="p-button-text p-button-rounded p-button-plain mr-2"
            [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
          ></button>
          <b>
            {{
              ((
                group[model.groupBy]
                | fieldValue
                  : groupByColumn?.fieldType
                  : groupByColumn?.pipes
                  : group
                  : groupByColumn?.users
                  : undefined
                  : groupByColumn?.displayFields
              )?.toString() | uppercase) ||
                '(NO ' + model.groupBy?.toUpperCase() + ')'
            }}</b
          >
        </div>
      </td>
    </tr>
  </ng-template>
  <ng-template
    [pTemplate]="model.groupBy ? 'rowexpansion' : 'body'"
    let-item
    let-index="rowIndex"
  >
    <tr
      [pReorderableRow]="index"
      [class.invalid]="
        model.id ? rowValidation[item[model.id]] === false : false
      "
      [class.selected]="isRowChecked(item)"
      [class.clickable]="isClickable"
    >
      <ng-container *ngIf="model && model.rowActions">
        <p-menu #rowActions [popup]="true" appendTo="body"></p-menu>
      </ng-container>
      <td *ngIf="model.supportsReordering" style="width: 3rem">
        <span class="pi pi-bars" pReorderableRowHandle></span>
      </td>
      <td *ngIf="isMultipleSelection" class="checkbox-cell">
        <p-tableCheckbox [value]="item"></p-tableCheckbox>
      </td>
      <ng-container *ngIf="isRowReadonly(item)">
        <ng-container
          *ngFor="let column of visibleColumns; trackBy: trackByColumn"
        >
          <ng-container
            *ngTemplateOutlet="
              cellValue;
              context: { $implicit: item, column: column }
            "
          ></ng-container>
        </ng-container>
        <td
          *ngIf="model.rowActions"
          class="row-action"
          alignFrozen="right"
          pFrozenColumn
          [frozen]="true"
        >
          <ng-container *ngIf="rowActionsTemplate; else defaultRowActions">
            <ng-container
              *ngTemplateOutlet="
                rowActionsTemplate;
                context: { $implicit: item }
              "
            ></ng-container>
          </ng-container>
          <ng-template #defaultRowActions>
            <button
              type="button"
              class="btn p-0"
              (click)="showRowActions(item, $event)"
            >
              <i class="pi pi-ellipsis-v"></i>
            </button>
          </ng-template>
        </td>
      </ng-container>
      <td *ngIf="!isRowReadonly(item)" colspan="100%">
        <temp-form
          table
          [model]="model.form"
          [value]="item"
          [suggestedValue]="
            model.suggestedRows
              ? (model.suggestedRows[index] | async)
              : undefined
          "
          #inlineFormRef
        >
          <temp-inline-form-actions
            inline-actions
            *ngIf="!isRowReadonly(item) && !model.hideFormActions"
            (submit)="submitInlineForm(item, inlineFormRef.submit())"
            (cancel)="cancelInlineForm(item)"
          ></temp-inline-form-actions>
        </temp-form>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <tr class="empty">
      <td [attr.colspan]="totalCollspan">
        <temp-empty-table></temp-empty-table>
      </td>
    </tr>
  </ng-template>

  <ng-template pTemplate="paginatorleft">
    <div class="checked-info" *ngIf="selectedRows.length">
      <i class="pi pi-check-square"></i>
      {{ selectedRows.length }}
      {{ ('shared.terms.selected' | translate).toLowerCase() }}
    </div>
  </ng-template>
  <!-- we also need right tempalte so default paginator is centered -->
  <ng-template pTemplate="paginatorright">
    <div class="sh-footer" *ngIf="footerTemplate">
      <ng-container *ngTemplateOutlet="footerTemplate"></ng-container>
    </div>
  </ng-template>
</p-table>

<ng-template #cellValue let-item let-column="column">
  <td
    [attr.type]="column.fieldType"
    (click)="onRowSelect(item)"
    (dblclick)="onRowDblClick(item)"
  >
    <ng-container *ngIf="cellTemplate; else defaultCell">
      <ng-container
        *ngTemplateOutlet="
          cellTemplate;
          context: { $implicit: item, column: column }
        "
      ></ng-container>
    </ng-container>

    <ng-template #defaultCell>
      <ng-container [ngSwitch]="true">
        <ng-container
          *ngSwitchCase="column.fieldType === FieldType.ProgressBar"
        >
          <sh-progress-bar
            *ngIf="item[column.key]"
            [value]="item[column.key].Progress"
            [total]="item[column.key].Total"
            [colorMap]="column.progressConfig?.colorMap"
            [format]="column.progressConfig?.format"
            [type]="column.progressConfig?.type"
          ></sh-progress-bar>
        </ng-container>

        <sh-copy-content-wrapper
          [show]="column.showCopyButton"
          *ngSwitchDefault
        >
          {{
            item[column.key]
              | fieldValue
                : column.fieldType
                : column.pipes
                : item
                : column.users
                : undefined
                : column.displayFields
          }}
          {{ column.appendText ?? '' }}
        </sh-copy-content-wrapper>
      </ng-container>
    </ng-template>
  </td>
</ng-template>

<ng-container *ngIf="model && model.rowActions">
  <p-menu #rowActions [popup]="true" appendTo="body"></p-menu>
</ng-container>
